import React from 'react';
import MinimalProductPrice from 'components/Common/Prices/MinimalProductPrice/MinimalProductPrice';
import PricesSize from 'components/Common/Prices/ProductPrice/types';
import styles from './LpShopifyCatalogItem.module.scss';
import { LPCatalogItemProps } from '../LPCatalogItem/LPCatalogItem';

const LpShopifyCatalogItem: React.FC<LPCatalogItemProps> = ({ image, title, referenceUrl, abstractProduct }) => {
  return (
    <div className={styles.card}>
      <a href={referenceUrl} className={styles.cardImageContainer}>
        <img src={image} alt="Item" className={styles.cardImage} />
      </a>
      {title && (
        <a href={referenceUrl} className={styles.cardText}>
          {title}
        </a>
      )}
      <div className={styles.lpCatalogItemPrice}>
        <MinimalProductPrice
          categoryId={abstractProduct.categoryId}
          quantity={1}
          product={abstractProduct}
          size={PricesSize.sm}
          theme="landing"
        />
      </div>
    </div>
  );
};

export default LpShopifyCatalogItem;
